/** @jsxImportSource @emotion/react */
import React from "react"
import { useTranslation } from "react-i18next"
import { withMyTheme } from "../../theme/theme"
import { css } from "@emotion/react"
import { ImageResource } from "../../resources/ImageResource"
import { Typography } from "@mui/material"
import { Fullscreen } from "../../components/Fullscreen"
import { isMobile, mobileCss } from "../../util/isMobile"
import { NavDesktop } from "../navigation/NavDesktop"
import { NavMobile } from "../navigation/NavMobile"
import { MyButton } from "../../components/button/MyButton"
import { ArrowForward } from "@mui/icons-material"
import { Navigation } from "../../navigation/Navigation"
import { CONTACT_ID } from "../contact/Contact"
import { scrollToSection } from "../../util/scroll"


const TitleContainerStyle = withMyTheme((theme) => `
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 100vh;
    background-image: 
        linear-gradient(to right, #ffffffbb 0%, #ffffffcc 35%, transparent 70%),
        url(${ImageResource.startBackground});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    ${mobileCss(`
        flex-direction: column;
        justify-content: space-between;
        min-height: 100vh;
        background-image: 
            linear-gradient(to bottom, rgba(255,255,255,1) 0%, transparent 20%, transparent 40%, rgba(255,255,255,0.7) 60%, rgba(255,255,255,0.9) 100%),
            url(${ImageResource.startBackgroundMobile});
        position: relative;
    `)}
`);



const ContentStyle = withMyTheme(() => `
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: 50%;
    margin-right: 5vw;
    margin-left: 10vw;

    ${mobileCss(`
        width: 100%;
        margin-left: 0;
        margin-right: 0;
        align-items: center;
        text-align: center;
        margin-bottom: 0;
        padding-bottom: 2rem;
    `)}
`)

const LogoStyle = withMyTheme(() => `
    width: 400px;
    margin-bottom: 2.5rem;

    ${mobileCss(`
        width: 50%;
        margin-bottom: 0;
        align-self: flex-start;
        margin-left: 3vh;
        margin-top: 3vh;
    `)}
`)

const HeaderTextStyle = withMyTheme((theme) => `
    font-family: 'Great Vibes', serif;
    font-size: 2.2rem;
    color: #000;
    font-family: ${theme.typography.h1.fontFamily};
    text-align: left;
    margin-bottom: 1.5rem;
    font-weight: 400;

    ${mobileCss(`
        font-size: 1.8rem;
        text-align: center;
        margin-bottom: 1rem;
    `)}
`)

const DescriptionStyle = withMyTheme((theme) => `
    font-family: 'Cormorant', serif;
    font-size: 1.5rem;
    color: #000;
    text-align: left;
    max-width: 600px;
    line-height: 1.5;
    margin-bottom: 1.5rem;

    ${mobileCss(`
        font-size: 1.8rem;
        text-align: center;
        margin-bottom: 1rem;
        padding: 0 1rem;
    `)}
`);

const PriceDescriptionStyle = withMyTheme((theme) => `
    font-family: 'Cormorant', serif;
    font-size: 2rem;
    font-weight: 700;
    color: ${theme.palette.primary.main};
    text-align: left;
    max-width: 600px;
    line-height: 1.5;
    margin-bottom: 1.5rem;
    padding: 1rem 1.5rem;
    background-color: rgba(255, 255, 255, 0.50);
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

    ${mobileCss(`
        font-size: 2.2rem;
        text-align: center;
        margin-bottom: 1rem;
        padding: 0.8rem 1.2rem;
    `)}
`);

const ButtonStyle = withMyTheme(() => `
    margin-top: 1.5rem;
    ${mobileCss(`
        margin-top: 1rem;
    `)}
`)

const MobileContentContainerStyle = withMyTheme(() => `
    display: none;
    
    ${mobileCss(`
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 90%;
        padding: 1rem;
        margin-bottom: 2vh;
    `)}
`)

export const Title = () => {
    const { t } = useTranslation();
    const mobile = isMobile();

    return <Fullscreen additionalCss={TitleContainerStyle}>
        <Navigation />
        {mobile ? (
            // Mobile layout
            <>
                <img src={ImageResource.logo} alt="Weddie Site Logo" css={LogoStyle} />
                <div css={MobileContentContainerStyle}>
                    <Typography css={HeaderTextStyle}>{t('title.headerText')}</Typography>
                    <Typography css={DescriptionStyle}>{t('title.descriptionLine1')}</Typography>
                    <Typography css={PriceDescriptionStyle}>
                        <span css={css`text-decoration: line-through; opacity: 0.7; margin-right: 10px;`}>699 PLN</span>
                        {t('title.descriptionLine2')}
                    </Typography>
                    <MyButton text={t('title.callToAction')} onClick={() => scrollToSection(CONTACT_ID)} variant="primary" endIcon={<ArrowForward />} additionalCss={ButtonStyle} />
                </div>
            </>
        ) : (
            // Desktop layout - unchanged
            <div css={ContentStyle}>
                <img src={ImageResource.logo} alt="Weddie Site Logo" css={LogoStyle} />
                <Typography css={HeaderTextStyle}>{t('title.headerText')}</Typography>
                <Typography css={DescriptionStyle}>{t('title.descriptionLine1')}</Typography>
                <Typography css={PriceDescriptionStyle}>
                    <span css={css`text-decoration: line-through; opacity: 0.7; margin-right: 10px;`}>699 PLN</span>
                    {t('title.descriptionLine2')}
                </Typography>
                <MyButton text={t('title.callToAction')} onClick={() => scrollToSection(CONTACT_ID)} variant="primary" endIcon={<ArrowForward />} additionalCss={ButtonStyle} />
            </div>
        )}
    </Fullscreen>
};

